// removed by extract-text-webpack-plugin
module.exports = {"Modal":"-name__-loca-__32_-a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 158
// module chunks = 0